var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDeleteIcon = function SvgDeleteIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66667 12.0064C7.03533 12.0064 7.33333 11.7084 7.33333 11.3398V7.33976C7.33333 6.9711 7.03533 6.6731 6.66667 6.6731C6.298 6.6731 6 6.9711 6 7.33976V11.3398C6 11.7084 6.298 12.0064 6.66667 12.0064Z",
    fill: "#B2B5B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33415 12.0064C9.70281 12.0064 10.0008 11.7084 10.0008 11.3398V7.33976C10.0008 6.9711 9.70281 6.6731 9.33415 6.6731C8.96548 6.6731 8.66748 6.9711 8.66748 7.33976V11.3398C8.66748 11.7084 8.96548 12.0064 9.33415 12.0064Z",
    fill: "#B2B5B2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0085 13.034C10.9998 13.2033 10.8365 13.336 10.6771 13.3346H5.31245C5.15912 13.3173 5.00512 13.204 4.99645 13.0293L4.56445 5.33329H11.4225L11.0085 13.034ZM6.66439 3.07729C6.66439 2.85463 6.85306 2.66663 7.07572 2.66663H8.92105C9.14772 2.66663 9.33239 2.85129 9.33239 3.07729V3.99996H6.66439V3.07729ZM13.3328 3.99992H12.1742C12.1702 3.99992 12.1662 3.99659 12.1615 3.99659C12.1535 3.99592 12.1468 3.99992 12.1382 3.99992H10.6655V3.07725C10.6655 2.11592 9.88351 1.33325 8.92085 1.33325H7.07551C6.11351 1.33325 5.33085 2.11592 5.33085 3.07725V3.99992H2.66618C2.29818 3.99992 1.99951 4.29792 1.99951 4.66659C1.99951 5.03525 2.29818 5.33325 2.66618 5.33325H3.22951L3.66484 13.0979C3.70685 13.9713 4.43885 14.6686 5.29151 14.6686C5.30351 14.6686 5.31551 14.6679 5.32751 14.6679H10.6608H10.6988C11.5655 14.6679 12.2982 13.9719 12.3402 13.1026L12.7575 5.33325H13.3328C13.7015 5.33325 13.9995 5.03525 13.9995 4.66659C13.9995 4.29792 13.7015 3.99992 13.3328 3.99992Z",
    fill: "#B2B5B2"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDeleteIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete-icon.f2b9a941.svg";
export { ForwardRef as ReactComponent };